import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export interface OnlineOrderItem {
  product_id: string;
  stock_id: string;
  qty: number;
  product_name?: string;
  batch_no?: string;
  price?: number;
}

export interface OnlineOrder {
  id: string;
  type: "whatsapp" | "online";
  customer_phone: string;
  customer_name?: string | null;
  order_details: string;
  items?: OnlineOrderItem[];
  status: string;
  created_at?: string;
  updated_at?: string;
}

export const GetOnlineOrders = async (params?: {
  search?: string;
  status?: string;
  type?: string;
  page?: number;
  limit?: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/online-orders`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load online orders.",
      data: { data: [] },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateOnlineOrder = async (payload: {
  type: "whatsapp" | "online";
  customer_phone: string;
  customer_name?: string | null;
  order_details: string;
  items?: OnlineOrderItem[];
  status?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/online-orders/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create online order.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateOnlineOrder = async (payload: {
  id: string;
  type: "whatsapp" | "online";
  customer_phone: string;
  customer_name?: string | null;
  order_details: string;
  items?: OnlineOrderItem[];
  status: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/online-orders/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update online order.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteOnlineOrder = async (payload: {
  id: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/online-orders/delete`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete online order.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
